import _ from 'lodash';
import React, { useState } from 'react';

import { useTranslation } from '../../../../custom-hooks/useTranslation';
import DashboardDialog from '../DashboardDialog';

const TableEdit = ({ part, tab, onAccept, onCancel }) => {
  const [data, setData] = useState({ part, tab });
  const translateString = useTranslation();

  function onChange(updates) {
    const clonedData = JSON.parse(JSON.stringify(data));

    updates.forEach(({ path, value }) => {
      _.set(clonedData, path, value);
    });

    setData(clonedData);
  }

  const cancelButton = {
    label: translateString('Cancel'),
    onClick: onCancel,
  };

  const acceptButton = {
    label: translateString('Accept'),
    onClick: () => onAccept(data),
  };

  return (
    <DashboardDialog
      data={data}
      buttonProps={[cancelButton, acceptButton]}
      onChange={onChange}
      onClose={onCancel}
    />
  );
};

export default TableEdit;
